// extracted by mini-css-extract-plugin
module.exports = {"priority":"priority-3o3o8","paper":"paper-10Weo"};